import configureStore from "./ConfigStore"
import { rootReducer } from "./RootReducers"

export default configureStore(rootReducer)
